<template lang="html">
  <div class="col-12 col-xl-10 offset-xl-1 col-tab-2">
    <h5 class="tab-title">Número telefónico y SIM CARD</h5>

    <div class="d-block mt-3">
      <h5 class="subtitle">¿Qué es un DN o Número Digital?</h5>
      <p>
        Por sus siglas en inglés Digital Number es el número digital a 10 dígitos con todo y lada que se asigna a una tarjeta sim para que lo utilice un usuario.
      </p>

      <br />
      <h5 class="subtitle">¿Qué es una tarjeta SIM?</h5>
      <p>
        La tarjeta SIM o Subscriber Identity Module es una pequeña tarjeta de plástico que tiene un chip pegado a ella, y que tienes que insertar en tu teléfono móvil o Smartphone. En este chip, almacena de manera segura tu número de teléfono, así como las claves de acceso de un usuario concreto en una operadora de telefonía.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
}
</script>
